import { render, staticRenderFns } from "./DefaultSidebar.vue?vue&type=template&id=537a14ba"
import script from "./DefaultSidebar.vue?vue&type=script&lang=js"
export * from "./DefaultSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports